module.exports = __webpack_public_path__ + "static/img/button_arrow.c4e55c62.png";